import React, { useState, useRef } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import api from '../api/client';

export default function VerifyEmail() {
  const location = useLocation();
  const navigate = useNavigate();
  const [email, setEmail] = useState(location.state?.email || '');
  const daLogin = !!location.state?.daLogin;
  const [codice, setCodice] = useState(['','','','','','']);
  const [error, setError]   = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const [resending, setResending] = useState(false);
  const refs = useRef([]);

  const handleDigit = (i, val) => {
    if (!/^\d?$/.test(val)) return;
    const next = [...codice];
    next[i] = val;
    setCodice(next);
    if (val && i < 5) refs.current[i + 1]?.focus();
  };

  const handleKeyDown = (i, e) => {
    if (e.key === 'Backspace' && !codice[i] && i > 0) refs.current[i - 1]?.focus();
  };

  const handlePaste = (e) => {
    const text = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, 6);
    if (text.length === 6) {
      setCodice(text.split(''));
      refs.current[5]?.focus();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    const code = codice.join('');
    if (code.length < 6) { setError('Inserisci il codice completo'); return; }
    setLoading(true);
    try {
      const { data } = await api.post('/auth/verify-email', { email, codice: code });
      const daApprovare = data?.esito === 'da_approvare';
      setSuccess(daApprovare ? data.message : 'Email verificata! Reindirizzamento...');
      setTimeout(() => navigate('/login'), daApprovare ? 6000 : 1500);
    } catch(err) {
      setError(err.response?.data?.error || 'Codice non valido');
    } finally { setLoading(false); }
  };

  const handleResend = async () => {
    setResending(true); setError('');
    if (!email.trim()) { setError('Scrivi la tua email'); setResending(false); return; }
    try {
      await api.post('/auth/resend-code', { email });
      setSuccess('Nuovo codice inviato!');
      setTimeout(() => setSuccess(''), 3000);
    } catch(err) {
      setError(err.response?.data?.error || 'Errore');
    } finally { setResending(false); }
  };

  return (
    <div style={s.page}>
      <div style={s.card}>
        <div style={s.logo}>B-CHEERS ASD</div>
        <div style={s.sub}>VERIFICA EMAIL</div>
        {daLogin ? (
          <p style={s.desc}>
            La tua email non è ancora confermata. Se il codice ricevuto è scaduto (vale 15 minuti) premi
            <strong> Mandami un nuovo codice</strong>, poi scrivilo qui sotto.
          </p>
        ) : (
          <p style={s.desc}>
            Abbiamo inviato un codice a 6 cifre a<br/>
            <strong style={{ color:'#F4600C' }}>{email || 'la tua email'}</strong>
          </p>
        )}
        {(daLogin || !location.state?.email) && (
          <input style={{ ...s.digit, width:'100%', height:'auto', padding:'12px 14px', fontSize:'var(--font-size-sm)', textAlign:'left', marginBottom:'16px', boxSizing:'border-box' }}
            type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="La tua email" autoCapitalize="none" />
        )}
        <form onSubmit={handleSubmit} style={s.form}>
          <div style={s.digits} onPaste={handlePaste}>
            {codice.map((d, i) => (
              <input
                key={i}
                ref={el => refs.current[i] = el}
                style={{ ...s.digit, borderColor: d ? '#F4600C' : 'var(--border2)' }}
                type="text" inputMode="numeric" maxLength={1}
                value={d}
                onChange={e => handleDigit(i, e.target.value)}
                onKeyDown={e => handleKeyDown(i, e)}
                autoFocus={i === 0}
              />
            ))}
          </div>
          {error   && <div style={s.error}>{error}</div>}
          {success && <div style={s.ok}>{success}</div>}
          <button type="submit" style={{ ...s.btn, opacity: loading ? 0.7 : 1 }} disabled={loading}>
            {loading ? 'VERIFICA...' : 'VERIFICA'}
          </button>
        </form>
        <div style={s.footer}>
          Non hai ricevuto il codice?{' '}
          <button style={s.linkBtn} onClick={handleResend} disabled={resending}>
            {resending ? 'Invio...' : daLogin ? 'Mandami un nuovo codice' : 'Rinvia'}
          </button>
        </div>
        <div style={{ ...s.footer, marginTop:'8px' }}>
          <Link to="/login" style={s.link}>Torna al login</Link>
        </div>
      </div>
    </div>
  );
}

const s = {
  page:    { minHeight:'100vh', background:'var(--bg)', display:'flex', alignItems:'center', justifyContent:'center', padding:'20px' },
  card:    { background:'var(--bg)', border:'1px solid var(--border)', borderRadius:'16px', padding:'48px 40px', width:'100%', maxWidth:'400px', textAlign:'center' },
  logo:    { fontFamily:"'Barlow Condensed'", fontSize: 'var(--font-size-title)', fontWeight:'800', color:'#F4600C', letterSpacing:'3px', marginBottom:'4px' },
  sub:     { fontSize:'var(--font-size-xs)', fontWeight:'700', color:'var(--text-dim)', letterSpacing:'2px', marginBottom:'24px' },
  desc:    { color:'var(--text-dim)', fontSize:'var(--font-size-sm)', marginBottom:'28px', lineHeight:'1.6' },
  form:    { display:'flex', flexDirection:'column', gap:'16px' },
  digits:  { display:'flex', gap:'10px', justifyContent:'center' },
  digit:   { width:'min(48px, 11vw)', height:'56px', padding:0, textAlign:'center', fontSize: 'var(--font-size-xl)', fontWeight:'800', background:'var(--bg-input)', border:'1px solid var(--border2)', borderRadius:'10px', color:'var(--text)', outline:'none' },
  error:   { background:'#EF444420', border:'1px solid #EF444440', borderRadius:'8px', padding:'10px 14px', color:'#EF4444', fontSize:'var(--font-size-sm)', fontWeight:'600', textAlign:'left' },
  ok:      { background:'#22c55e20', border:'1px solid #22c55e40', borderRadius:'8px', padding:'10px 14px', color:'#22c55e', fontSize:'var(--font-size-sm)', fontWeight:'600' },
  btn:     { background:'#F4600C', color:'#fff', border:'none', borderRadius:'10px', padding:'14px', fontSize:'var(--font-size-sm)', fontWeight:'700', cursor:'pointer', letterSpacing:'1px' },
  footer:  { marginTop:'16px', fontSize:'var(--font-size-sm)', color:'var(--text-dim)' },
  linkBtn: { background:'none', border:'none', color:'#F4600C', fontWeight:'700', cursor:'pointer', fontSize:'inherit', padding:'0' },
  link:    { color:'#F4600C', textDecoration:'none', fontWeight:'700' },
};
